import React from 'react';
import './overview.scss';
import { Container, Grid, Link } from '@material-ui/core';
import AnimalTags from 'components/animal-tags';
import { OverviewProps } from './overview-props';

/**
 * Animal details overview section.
 * @param props
 */
export const Overview: React.FC<OverviewProps> = (props) => {
  const {
    animal,
  } = props;

  return (
    <>
      {animal && (
        <Container className="sg-overview">
          <div className="title-container">
            <h2>{animal.studId}</h2>
            <AnimalTags
              animal={animal}
              size="large"
              show="primary"
              showIcon="primary"
              showWebsite
              showTooltip={false}
            />
          </div>
          <div className="tags-container">
            <AnimalTags
              animal={animal}
              show="secondary"
              showWebsite
              showTooltip={false}
            />
          </div>
          <Grid className="details-container" container>
            <Grid className="details-container__grid" item xs={12} sm={6} md={4}>
              <Grid container>
                <Grid className="text--bold" item xs={3}>ID</Grid>
                <Grid item xs={9}>{animal.displayedId}</Grid>
              </Grid>
              <Grid container>
                <Grid className="text--bold" item xs={3}>Breed</Grid>
                <Grid item xs={9}>{animal.breed}</Grid>
              </Grid>
              <Grid container>
                <Grid className="text--bold" item xs={3}>Sex</Grid>
                <Grid item xs={9}>{animal.sexDesc}</Grid>
              </Grid>
              <Grid container>
                <Grid className="text--bold" item xs={3}>Drop</Grid>
                <Grid item xs={9}>{animal.drop}</Grid>
              </Grid>
            </Grid>
            <Grid className="details-container__grid" item xs={12} sm={6} md={4}>
              <Grid container>
                <Grid className="text--bold" item xs={3}>Progeny</Grid>
                <Grid item xs={9}>{animal.progenyNum}</Grid>
              </Grid>
              <Grid container>
                <Grid className="text--bold" item xs={3}>Flocks</Grid>
                <Grid item xs={9}>{animal.flockNum}</Grid>
              </Grid>
              <Grid container>
                <Grid className="text--bold" item xs={3}>Location</Grid>
                <Grid item xs={9}>{animal.address}</Grid>
              </Grid>
            </Grid>
            <Grid className="details-container__grid" item xs={12} sm={6} md={4}>
              <Grid container>
                <Grid className="text--bold" item xs={3}>Stud</Grid>
                <Grid item xs={9}>{animal.studName}</Grid>
              </Grid>
              <Grid container>
                <Grid className="text--bold" item xs={3}>Breeder</Grid>
                <Grid item xs={9}>{animal.breeder}</Grid>
              </Grid>
              <Grid container>
                <Grid className="text--bold" item xs={3}>Contact</Grid>
                <Grid item xs={9}>{animal.phone}</Grid>
              </Grid>
              <Grid container>
                <Grid className="text--bold" item xs={3}>Website</Grid>
                <Grid item xs={9}>
                  {animal.website ? (
                    <Link
                      className="lower"
                      href={animal.website}
                      target="_blank"
                      rel="noopener"
                    >
                      View website
                    </Link>
                  )
                    : (
                      <span>—</span>
                    )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      )}
    </>
  );
};
